import React, { useRef } from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const HeadingBarViewer = (props) => {
    const { title, buttonLabel, onButtonClick, isAttachmentsButton, attachmentsDataModel, blockConfig, isGlobalDownloadEnable, isGobalDownloadEnable, onGlobalDownload, globalDownloadTitle, updateButtonLabel, onUpdateButtonClick, selectedDataModel } = props
    const globalDownloadOn =
        Boolean(isGlobalDownloadEnable || isGobalDownloadEnable) && typeof onGlobalDownload === 'function'
    const { chartUniqueId } = props.data;
    const currentOpportunityId = props?.match?.params?.id;

    const isButtonEnabled = !props.enableWorkflow || (
        props.blockState?.['status'] !== 'Rejected' &&
        props.blockState?.['status'] !== 'Completed' &&
        props.blockState?.workflow &&
        props.blockState?.workflow?.currentRespondent?.id === props.members?._id
    );

    const fileInputRef = useRef(null);

    const acceptedFiles = blockConfig?.acceptedFiles || ["pdf", "doc", "docx", "zip", "xls", "xlsx", "csv", "txt", "jpg", "jpeg", "png", "gif", "bmp", "tiff", "webp", "svg", "ico", "apng", "heif", "heic"];

    const handleButtonClick = () => {
        if (isAttachmentsButton !== undefined && isAttachmentsButton !== null && isAttachmentsButton) {
            fileInputRef.current?.click();
        } else if (typeof onButtonClick === 'function') {
            onButtonClick();
        }
    };

    const handleUpdateButtonClick = () => {
        if (typeof onUpdateButtonClick === 'function') {
            onUpdateButtonClick();
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            handleUploadAttachments(file);
            event.target.value = '';
        }
    };

    const handleUploadAttachments = (file) => {
        props.uploadAttachmentOpportunity(payloadForUploadSupportingDocument(file));
    };

    const payloadForUploadSupportingDocument = (file) => {
        const formData = new FormData();
        formData.append('file', file);
        for (let [key, value] of formData.entries()) {
            console.log('FormData entry:', key, value);
        }
        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${chartUniqueId}_getsingleobligation`]
        })

        props.clearReduxDataOfCurrentComponent({
            key: 'document',
            subKey: [`${chartUniqueId}_documentsfromIds`]
        })

        return {
            formData,
            appId: props.match.params.appid,
            dataModelId: selectedDataModel,
            subDataModelId: attachmentsDataModel,
            opportunityId: props?.match?.params?.id || currentOpportunityId,
            dataUniqueId: `${chartUniqueId}_upload_attachments_opp`,
        };
    };

    const showActionButton = Boolean(buttonLabel) && isButtonEnabled;
    const showUpdateButton = Boolean(updateButtonLabel) && isButtonEnabled;

    return (
        <React.Fragment>
            {
                title && (
                    <div style={{ height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', boxSizing: 'border-box' }}>
                        <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                                <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                                </div>
                                <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#424242', fontStyle: 'normal', lineHeight: '24px' }}>{title}</Typography>
                            </div>
                            {globalDownloadOn ? (
                                <Tooltip title={globalDownloadTitle || 'Download'}>
                                    <IconButton
                                        size="small"
                                        aria-label={globalDownloadTitle || 'Download'}
                                        onClick={() => onGlobalDownload()}
                                        style={{ marginLeft: 4, padding: 4 }}
                                    >
                                        <img
                                            src="/media/createStepper/downloadIconNew.svg"
                                            alt=""
                                            style={{ width: 18, height: 18, display: 'block' }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                        </div>
                        {
                            (showActionButton || showUpdateButton) && (
                                <div style={{ height: '35px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                                    {showUpdateButton && (
                                        <Button
                                            style={{ color: '#3F51B5', border: '1px solid #3F51B5', borderRadius: '4px', height: '30px', padding: '12px', boxSizing: 'border-box' }}
                                            onClick={handleUpdateButtonClick}
                                        >
                                            {updateButtonLabel}
                                        </Button>
                                    )}
                                    {showActionButton && (
                                        <Button
                                            style={{ color: '#3F51B5', border: '1px solid #3F51B5', borderRadius: '4px', height: '30px', padding: '12px', boxSizing: 'border-box' }}
                                            onClick={handleButtonClick}
                                        >
                                            {buttonLabel}
                                        </Button>
                                    )}
                                    {isAttachmentsButton && (
                                        <input
                                            ref={fileInputRef}
                                            type="file"
                                            style={{ display: 'none' }}
                                            accept={acceptedFiles?.join(',')}
                                            onChange={handleFileChange}
                                        />
                                    )}
                                </div>
                            )
                        }
                    </div>
                )
            }
        </React.Fragment>

    )
}

export default HeadingBarViewer
